import axios from 'axios';
import router from '@/router';
import store from '@/store';

const apiUrl = process.env.VUE_APP_URL + '/api';

const http = axios.create({
    baseURL: apiUrl,
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Add token to request
http.interceptors.request.use((config) => {
    const token = store.getters.accessToken;
    if (token) {
        config.headers.Authorization = token;
    }

    return config;
});

// Token expired
http.interceptors.response.use(
    response => response,
    async error => {
        const status = error.response?.status;
        const message = error.response?.data?.message;

        // TODO: Pedir para o back-end padronizar o status code
        const invalidTokenMessage = (message == 'Token inválido.' || message == 'Token expirado.');        
        const tokenErrorStatusCode = new Set([400, 401]);
        if (tokenErrorStatusCode.has(status) && invalidTokenMessage) {
            console.log('Token inválido');
            await store.dispatch('setSessionExpiredMessage', {
                showMessage: true,
            });
            await store.dispatch('makeLogout');

            router.push('/login');
        }

        return Promise.reject(error);
    }
);

export default http;
